export default "__VITE_ASSET__C6MBu2rG__"